import React from 'react'

const Ordenes = () => {
  return (
    <div>Ordenes</div>
  )
}

export default Ordenes